<template>
  <div class="flex flex-wrap mt-4">
    <div class="w-full mb-12 px-4">
      <card-record
        title="Hora"
        :resource="resource"
        primaryKey="idhora"
        :record="record"
        :columns="columns"
        @saveChanges="handleSave"
        :service="service"
        :readonly="readonlyForm"
      />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import CardRecord from "@/components/Cards/CardRecord.vue";
import HoraService from "@/services/hora.service";
import { hora } from "@/models/hora";
import DateUtils from "@/utils/dateUtils";

export default {
  components: {
    CardRecord,
  },

  data() {
    return {
      record: {},
      columns: hora,
      service: HoraService,
    };
  },

  computed: {
    ...mapState({
      userInfo: (state) => state.auth.user,
    }),

    isPersonal() {
      return !this.userInfo?.roles.includes("admin");
    },

    currentRoutePath() {
      return this.$route.path;
    },

    isMisHoras() {
      return this.currentRoutePath.includes("/mis-horas");
    },

    resource() {
      return this.isMisHoras ? "mis-horas" : "horas";
    },

    readonlyForm() {
      if (!this.isPersonal) {
        return false;
      }

      const currentDate = new Date();

      let startLimit = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate() - 6,
      );

      // if (currentDate.getMonth() > startLimit.getMonth()) {
      //   startLimit = new Date(
      //     currentDate.getFullYear(),
      //     currentDate.getMonth(),
      //     1
      //   );
      // }

      if (
        this.record?.fecha &&
        DateUtils.parseDate(this.record.fecha) >= startLimit
      ) {
        return false;
      }

      return true;
    },
  },

  watch: {
    $route: {
      immediate: true,
      handler(/*to, from*/) {
        HoraService.get(this.$route.params.id)
          .then((data) => {
            const { record } = data;
            if (!record.idhora) {
              const paramFecha = this.$route.query.fecha;
              record.fecha = paramFecha
                ? paramFecha
                : DateUtils.formatDate(new Date());
              // Asignar el personal del usuario actual como valor por defecto
              if (
                this.$route.params.id === "new" &&
                this.userInfo?.idpersonal
              ) {
                record.idpersonal = this.userInfo.idpersonal;
              }
            }
            this.record = record;
          })
          .catch((response) => {
            console.log(response);
          });
      },
    },
  },

  methods: {
    handleSave(record) {
      this.record = record;
    },
  },
};
</script>
